import styled from 'styled-components';
import PlanRegModal from './PlanRegModal';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TableUnit from './TableUnit';
import * as C from '../../../ui/common/CommonStyles';
import { Box, Button, Group, Pagination } from '@mantine/core';
import CustomSearch from '../../../ui/search/customSearch';
import { useCustomSearch } from '../../../../shared/hook/useCustomSearch';
import useGetPlans from '../../../../shared/hook/queries/useGetPlans';
import type { IServicePlan } from '../../../../shared/types/plan';

const options = [{ value: 'planName', label: '요금제명' }];

const PlanManagement = () => {
  // 모달 상태값
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // 생성/수정 상태값
  const [isEdit, setIsEdit] = useState<boolean>(false);
  // 수정할 요금제 id
  const [editItemId, setEditItemId] = useState<number | null>(null);
  // 클라이언트단 url parameter 설정
  const [searchParams, setSearchParams] = useSearchParams('');
  const searchWord = searchParams.get('keyword') || '';
  const searchCategory = searchParams.get('searchCategory') || 'planName';
  const page = searchParams.get('pg') || '1';
  const size = searchParams.get('pgSize') || '10';

  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: 'planName',
    searchKey: 'searchCategory',
    pageKey: 'pg',
  });

  const { data: plans, refetch } = useGetPlans({
    pg: Number(page),
    pgSize: Number(size),
    searchCategory: searchCategory,
    keyword: searchWord,
  });

  const openModal = () => {
    setIsOpen(true);
  };

  const onClickPlan = (plan: IServicePlan) => {
    return () => {
      setIsEdit(true);
      setEditItemId(plan.id);
      openModal();
    };
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">요금제 생성/관리</div>
      </C.TitleBox>
      <C.ListBox>
        <C.Toolbar>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchCategory}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={options}
          />

          <Box>
            <Button
              h="100%"
              variant="filled"
              color="secondary.5"
              onClick={() => {
                setIsEdit(false);
                openModal();
              }}
            >
              요금제 생성
            </Button>
          </Box>
        </C.Toolbar>
        <TableWrap>
          <TableUnit data={plans?.list} onClickPlan={onClickPlan} />
          {plans && plans?.totalCount > 0 ? (
            <Group justify="center" mt="md">
              <Pagination
                total={Math.ceil((plans?.totalCount ?? 0) / Number(size))}
                value={Number(page)}
                onChange={(value) => {
                  setSearchParams({
                    pg: String(value),
                    pgSize: size,
                    searchCategory: searchCategory,
                    keyword: searchWord,
                  });
                }}
              />
            </Group>
          ) : null}
        </TableWrap>
      </C.ListBox>
      <PlanRegModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        editItemId={editItemId}
        setEditItemId={setEditItemId}
        refetch={refetch}
      />
    </div>
  );
};

export default PlanManagement;

const TableWrap = styled.div`
  width: 100%;
`;
